import { render, staticRenderFns } from "./entrancePopup.vue?vue&type=template&id=39499618&scoped=true&"
import script from "./entrancePopup.vue?vue&type=script&lang=js&"
export * from "./entrancePopup.vue?vue&type=script&lang=js&"
import style0 from "./entrancePopup.vue?vue&type=style&index=0&id=39499618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39499618",
  null
  
)

export default component.exports